import React, { useEffect, Fragment } from 'react';
import { Button, Row, Col, Form, message } from 'antd';
import FormGroup from 'Molecules/FormGroup';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import { useTranslate } from 'Translate';

const _ = require('lodash');

export default (props) => {
  const { id, data, addCustomer, editCustomer, reloadApi, mode, meta, allowedEdit } = props;
  const { control, formState: { errors }, handleSubmit, setValue } = useForm();
  const i18n = useTranslate();
    const { t } = i18n;

  const formFields = [
    {
      name: 'first_name',
      label: t("Crm.first_name"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'last_name',
      label: t("Crm.last_name"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      type: 'select',
      label: t("Crm.calling_code"),
      name: 'calling_code',
      twocol: false,
      options: meta?.calling_codes?.map((x) => ({ label: `${x.name} (+${x.calling_code})`, value: x.calling_code })),
      req: true,
      placeholder: t("General.please_select"),
      reqmessage: t("General.required"),
      colWidth: '0 1 50%',
      static: !allowedEdit
    },
    {
      type: 'input',
      name: 'phone',
      label: t("Outlet.phone_number"),
      req: true,
      placeholder: t("General.please_state"),
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      className: 'default-select',
      static: !allowedEdit
    },
    // {
    //   type: 'phone',
    //   name: 'phone',
    //   label: t("Outlet.phone_number"),
    //   req: true,
    //   placeholder: t("General.please_state"),
    //   twocol: false,
    //   phone: true,
    //   colWidth: '0 1 50%',
    //   reqmessage: t("General.required"),
    //   className: 'default-select',
    //   static: !allowedEdit
    // },
    {
      name: 'email',
      label: t("System.email"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      email: true,
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'dob',
      label: t("Crm.date_of_birth"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'date',
      format: 'YYYY-MM-DD',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      type: 'select',
      label: t("Crm.gender"),
      name: 'gender',
      twocol: false,
      options: meta?.genders?.map((x) => ({ label: x, value: x })),
      req: false,
      placeholder: t("General.please_select"),
      reqmessage: 'Gender Required',
      colWidth: '0 1 50%',
      static: !allowedEdit
    }
  ];

  useEffect(() => {
    if (data && 'id' in data && mode !== 'add') {
      if(data.calling_code) { 
        let temp = meta?.calling_codes?.find(x => x.calling_code == data.calling_code);
        setValue('calling_code', { label: `${temp.name} (+${temp.calling_code})`, value: temp.calling_code });
      }
      setValue('first_name', data.first_name);
      setValue('last_name', data.last_name);
      setValue('phone', data.phone);
      setValue('email', data.email);
      setValue('dob', data?.dob ? dayjs(data?.dob) : '');
      setValue('gender', data?.gender ? { label: data.gender, value: data.gender } : '');
    }
  }, [data]);

  const onFinish = async (val) => {
    props.setLoading(true);
    const payload = {
      ...val,
      gender: val?.gender?.value,
      calling_code: val?.calling_code?.value,
      dob: val?.dob ? dayjs(val?.dob).format("YYYY-MM-DD") : '',
      user_id: id
    }

    await (id ? editCustomer : addCustomer)(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t(`Success.customer_${id ? "updated" : "created"}`));
        setTimeout(() => reloadApi(res.data.data), 500);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
      <Row gutter={[20, 30]}>
        {formFields.map((item, idx) => (
          <Fragment key={idx}>
            <FormGroup item={item} control={control} errors={errors} />
          </Fragment>
        ))}
        {
          allowedEdit &&
          <Col span={24} className='text-right'>
            <Button size="large" htmlType='submit' className='green-btn attendance-success'>{t("General.save")}</Button>
          </Col>
        }
      </Row>
    </Form>
  )
}